import React, { useRef, useEffect } from "react"
import { Swiper, SwiperSlide } from "swiper/react"
import "swiper/css"
import { Autoplay, Navigation } from "swiper"
import { ApiServer } from "../../helpers/Api_help"

const CustomNavButton = ({ direction, onClick }) => (
  <div
    onClick={onClick}
    className={`custom-nav-button ${direction}`}
    style={{
      position: "absolute",
      top: "50%",
      [direction]: "10px",
      transform: "translateY(-50%)",
      width: "40px",
      height: "40px",
      borderRadius: "50%",
      backgroundColor: "#fff",
      boxShadow: "0 2px 10px rgba(0, 0, 0, 0.2)",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      zIndex: 10,
    }}
  >
    <i
      className={`fas fa-chevron-${direction === "left" ? "left" : "right"}`}
      style={{ fontSize: "16px", color: "#000" }}
    ></i>
  </div>
)

const PartnershipSlider = ({ Sponser }) => {
  const prevRef = useRef(null)
  const nextRef = useRef(null)

  return (
    <div style={{ position: "relative", padding: "0 50px" }}>
      {/* Custom Nav Buttons */}
      <CustomNavButton direction="left" onClick={() => prevRef.current?.click()} />
      <CustomNavButton direction="right" onClick={() => nextRef.current?.click()} />

      {/* Hidden default Swiper buttons (used for manual trigger) */}
      <div ref={prevRef} className="swiper-button-prev" style={{ display: "none" }}></div>
      <div ref={nextRef} className="swiper-button-next" style={{ display: "none" }}></div>

      <Swiper
        className="clients-swiper"
        speed={1500}
        slidesPerView={5}
        spaceBetween={30}
        loop={true}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        navigation={{
          prevEl: prevRef.current,
          nextEl: nextRef.current,
        }}
        onSwiper={(swiper) => {
  setTimeout(() => {
     if (swiper.params?.navigation && prevRef.current && nextRef.current) {
      swiper.params.navigation.prevEl = prevRef.current;
      swiper.params.navigation.nextEl = nextRef.current;

       if (!swiper.navigation) swiper.navigation = {};
      if (typeof swiper.navigation.init === "function") {
        swiper.navigation.init();
        swiper.navigation.update();
      }
    }
  });
}}

        // onSwiper={(swiper) => {
        //   // Attach navigation after refs are rendered
        //   setTimeout(() => {
        //     swiper.params.navigation.prevEl = prevRef.current
        //     swiper.params.navigation.nextEl = nextRef.current
        //     swiper.navigation.init()
        //     swiper.navigation.update()
        //   })
        // }}
        modules={[Autoplay, Navigation]}
        breakpoints={{
          1191: { slidesPerView: 5 },
          992: { slidesPerView: 4 },
          768: { slidesPerView: 3 },
          575: { slidesPerView: 2 },
          320: { slidesPerView: 1 },
          280: { slidesPerView: 1 },
        }}
      >
        {Sponser?.map((d, i) => (
          <SwiperSlide key={i}>
            <div className="clients-logo">
              <img
                className="img-thumbnail"
                src={`${ApiServer}assets/sponsorship/${d.logo}`}
                alt="NOT FOUND"
                style={{
                  width: 200,
                  height: 200,
                  objectFit: "contain",
                }}
              />
              <h6>{d.esp_name}</h6>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  )
}

export default PartnershipSlider





// import React from "react"
// // Import Swiper React components
// import { Swiper, SwiperSlide } from "swiper/react"
// //import { LazyLoadImage } from 'react-lazy-load-image-component';

// // Import Swiper styles
// import "swiper/css"

// //Images
// // import { Sponsers } from "../../constant/theme"

// // import Swiper core and required modules
// import { Autoplay, Pagination, Navigation } from "swiper"
// import { ApiServer } from "../../helpers/Api_help"

// //SwiperCore.use([EffectCoverflow,Pagination]);

// const PartnershipSlider = ({ Sponser }) => {
//   return (
//     <>
//       <Swiper
//         className="clients-swiper"
//         speed={1500}
//         // parallax={true}
//         slidesPerView={5}
//         spaceBetween={30}
//         loop={true}
//         autoplay={{
//           delay: 2000,
//           disableOnInteraction: false,
//         }}
//         //  pagination={{
//         //       clickable: true,
//         //     }}
//         // navigation={true}
//         modules={[Autoplay, Pagination, Navigation]}
//         // onAutoplayTimeLeft={onAutoplayTimeLeft}
//         breakpoints={{
//           1191: {
//             slidesPerView: 5,
//           },
//           992: {
//             slidesPerView: 4,
//           },
//           768: {
//             slidesPerView: 3,
//           },
//           575: {
//             slidesPerView: 2,
//           },
//           320: {
//             slidesPerView: 1,
//           },
//           280: {
//             slidesPerView: 1,
//           },
//         }}
//       >
//         {Sponser?.map((d, i) => (
//           <SwiperSlide key={i}>
//             <div className="clients-logo">
//               <img
//                 className="img-thumbnail"
//                 src={`${ApiServer}assets/sponsorship/${d.logo}`}
//                 alt="NOT FOUND"
//                 style={{
//                   width: 200,
//                   height: 200,
//                   // contain: "content",
//                   contain: "size",
//                   // objectFit: "contain",
//                 }}
//               />
//               <h6>{d.esp_name}</h6>
//             </div>
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </>
//   )
// }

// export default PartnershipSlider
